import React, { useCallback, useState } from "react"
import { Link } from "react-router-dom"
import { Progress } from "reactstrap"
import { useTranslation } from "react-i18next"

type Vendor = {
  name: string
  orderCount: number
  progressValue: number
}

const vendors: Vendor[] = [
  { name: "Vendor1", orderCount: 100, progressValue: 100 },
  { name: "Vendor2", orderCount: 90, progressValue: 90 },
  { name: "Vendor3", orderCount: 80, progressValue: 80 },
  { name: "Vendor4", orderCount: 70, progressValue: 70 },
  { name: "Vendor5", orderCount: 60, progressValue: 60 },
  { name: "Vendor6", orderCount: 50, progressValue: 50 },
  { name: "Vendor7", orderCount: 40, progressValue: 40 },
  { name: "Vendor8", orderCount: 30, progressValue: 30 },
  { name: "Vendor9", orderCount: 20, progressValue: 20 },
  { name: "Vendor10", orderCount: 10, progressValue: 10 },
]

enum Time {
  ALL = "dashboard_all",
  ONE_MONTH = "dashboard_oneMonth",
  SIX_MONTH = "dashboard_sixMonths",
  ONE_YEAR = "dashboard_oneYear",
}

const times: Time[] = [Time.ALL, Time.ONE_MONTH, Time.SIX_MONTH, Time.ONE_YEAR]

export const TopVendors = () => {
  const [currentTime, setCurrentTime] = useState(Time.ALL)

  const { i18n } = useTranslation()

  const handleTimeChange = useCallback((time: Time) => {
    setCurrentTime(time)
  }, [])

  return (
    <div className="d-flex flex-column gap-4">
      <h4 className="font-size-16 text-capitalize fw-semibold">
        {i18n.t("dashboard_topVendors")}
      </h4>
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-1 justify-content-start">
          {times.map((time, index) => (
            <button
              key={index}
              className={`font-size-12 fw-regular ${
                time === currentTime
                  ? "text-primary bg-primary-30"
                  : "bg-cyan-30 text-cyan"
              }`}
              style={{
                border: "none",
              }}
              onClick={() => handleTimeChange(time)}
            >
              {i18n.t(time)}
            </button>
          ))}
        </div>

        <Link
          to="/dashboard/top-vendors"
          className="btn btn-sm btn-outline-primary border-0 fw-medium font-size-16"
        >
          {i18n.t("dashboard_seeMore")}
        </Link>
      </div>
      <div className="">
        {vendors.map((item, index) => (
          <div
            key={index}
            className="d-flex align-items-center mb-3"
            style={{ gap: "10px" }}
          >
            <div
              className="flex-grow-1 fw-regular font-size-14"
              style={{ maxWidth: "120px" }}
            >
              {item.name}
            </div>

            <div className="flex-grow-1">
              <Progress
                value={item.progressValue}
                max={100}
                style={{
                  height: "14px",
                  borderStartStartRadius: "0px",
                  borderStartEndRadius: "4px",
                  borderEndStartRadius: "0px",
                  borderEndEndRadius: "4px",
                  backgroundColor: "#e9ecef",
                }}
                barStyle={{
                  backgroundImage: "linear-gradient(90deg, #095BA8, #00A0DC)",
                }}
              />
            </div>

            <div className="ms-2 fw-regular font-size-12">{item.orderCount}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
